import React, { useState, useRef, useEffect } from 'react';
import { MessageCircle, X, Send } from 'lucide-react';
import emailjs from '@emailjs/browser';
import './FloatingContact.css';

const FloatingContact = ({ offset = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');
  const form = useRef();
  const panelRef = useRef();

  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    const handleEsc = (e) => {
      if (e.key === 'Escape') setIsOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEsc);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEsc);
    };
  }, [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const result = await emailjs.sendForm(
        'service_ara3das',
        'template_brvw9z6',
        form.current,
        'PfL3QsTk4pTUONQvR'
      );
      if (result.status === 200) {
        setStatus('success');
        form.current.reset();
      }
    } catch (error) {
      setStatus('error');
      console.log(error);
    }
    setLoading(false);
    setTimeout(() => setStatus(''), 5000);
  };

  return (
    <div className={`floating-contact-wrapper ${offset ? 'is-offset' : ''}`} ref={panelRef}>
      {isOpen && (
        <div className="floating-contact-panel" role="dialog" aria-label="Contact us">
          <div className="floating-contact-header">
            <div>
              <h3 className="floating-contact-title">Message us</h3>
              <p className="floating-contact-subtitle">We usually reply within a day.</p>
            </div>
            <button
              type="button"
              className="floating-contact-close"
              onClick={() => setIsOpen(false)}
              aria-label="Close"
            >
              <X size={18} />
            </button>
          </div>

          <form ref={form} onSubmit={handleSubmit} className="floating-contact-form">
            <input
              type="text"
              name="user_name"
              placeholder="Your name"
              required
              className="floating-contact-input"
            />
            <input
              type="email"
              name="user_email"
              placeholder="Your email"
              required
              className="floating-contact-input"
            />
            <input
              type="tel"
              name="user_phone"
              placeholder="Phone (optional)"
              className="floating-contact-input"
            />
            <textarea
              name="message"
              placeholder="How can we help?"
              required
              className="floating-contact-textarea"
            />
            <button
              type="submit"
              disabled={loading}
              className="floating-contact-submit"
            >
              {loading ? 'Sending...' : (
                <>
                  Send <Send size={16} />
                </>
              )}
            </button>

            {status === 'success' && (
              <div className="floating-contact-success">
                Thanks! We'll be in touch soon.
              </div>
            )}
            {status === 'error' && (
              <div className="floating-contact-error">
                Something went wrong. Please try again.
              </div>
            )}
          </form>
        </div>
      )}

      <button
        type="button"
        className={`floating-contact-button ${isOpen ? 'is-open' : ''}`}
        onClick={() => setIsOpen((v) => !v)}
        aria-label={isOpen ? 'Close contact form' : 'Open contact form'}
        aria-expanded={isOpen}
      >
        {isOpen ? <X size={22} /> : <MessageCircle size={22} />}
        {!isOpen && <span className="floating-contact-button-label">Message us</span>}
      </button>
    </div>
  );
};

export default FloatingContact;
